let rootUrl;

if(window.location.origin === 'http://localhost:3000') {
    rootUrl = 'https://stage.vmedulife.com'; 
}else {
    rootUrl = "https://" + window.location.host;
}

export default {
    RootUrl: rootUrl,
};